import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";

import type { SignalState } from "../api/client";
import "./ld-signal";

export interface StripItem {
  source: string;
  state: SignalState | null;
  caption?: string;
}

@customElement("ld-signal-strip")
export class LdSignalStrip extends LitElement {
  @property({ attribute: false }) items: StripItem[] = [];
  @property({ type: Boolean, reflect: true }) compact = false;
  @property({ type: Boolean, reflect: true }) centered = false;

  static styles = css`
    :host { display: block; }
    .strip { display: flex; gap: 10px; flex-wrap: wrap; }
    :host([compact]) .strip { gap: 6px; }
    :host([centered]) .strip { justify-content: center; }
  `;

  render() {
    return html`<div class="strip">
      ${repeat(
        this.items,
        (item) => item.source,
        (item) => html`<ld-signal
          .code=${item.source}
          .state=${item.state}
          .caption=${item.caption}
          ?compact=${this.compact}
        ></ld-signal>`,
      )}
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "ld-signal-strip": LdSignalStrip;
  }
}
